module.exports = __webpack_public_path__ + "img/socioeconomic_livelihood_100px_bluebox.be0f357c.png";